/*
 * @Author: chenting chenting@cqliving.com
 * @Date: 2022-09-15 14:44:22
 * @LastEditors: chenting chenting@cqliving.com
 * @LastEditTime: 2023-01-03 09:48:31
 * @FilePath: \share-news-detail-pages\src\api\dataCollect\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import axios from "axios";
import request from "@/common/request";
// 埋点接口
export function dataCollect(parmas) {
  return axios.post(
    "https://dataconn.cqliving.com/" + "/user/data/dataCollect",
    parmas
  );
}

// 政务云埋点开关接口（全局开关，无请求参数） /getDataSwitch.htm.html
// 接口请求 html改静态化json
export function getHlxDataSwitch(parmas) {
  try {
    return request.get(
      "https://h5cloud.cqliving.com/statics/h5/res/getDataSwitch.json?t=" +
        new Date().getFullYear() +
        (new Date().getMonth() + 1) +
        new Date().getDate() +
        new Date().getHours()
    );
  } catch (error) {
    return axios.post(process.env.VUE_APP_BASE_API + "/getDataSwitch.html");
  }
}
export function getHlxDataSwitch2(parmas) {
  // axios.post(process.env.VUE_APP_BASE_API + "/getDataSwitch.html");
  return axios.get(
    process.env.VUE_APP_BASE_JSON + "/app/new/Config/global/getDataSwitch.json"
  );
}

/** ----------华龙芯app新闻埋点-------- */

// APP新闻浏览埋点接口   /statistics/news/browse
export function getHlxNewsRecord(parmas) {
  return request.post(
    process.env.VUE_APP_HLX_API + "/news/browse?isAjax=true",
    parmas
  );
}

// APP新闻浏览时长埋点接口  /statistics/news/browseTime
export function getHlxNewsRecordTime(parmas) {
  return request.post(
    process.env.VUE_APP_HLX_API + "/news/browseTime?isAjax=true",
    parmas
  );
}

// 微信二次分享埋点接口 埋点数据
export function hlxShareData(platform, is_success, fail_reason) {
  const _url = process.env.VUE_APP_HLX_API + "/share";
  let urlrouter = window.location.href.split("cid=")[1];
  let urlrouter2 = window.location.href.split("id=")[1];
  urlrouter.split("&") ? (urlrouter = urlrouter.split("&")[0]) : "";
  urlrouter2.split("&") ? (urlrouter2 = urlrouter2.split("&")[0]) : "";

  const source_id = urlrouter ? urlrouter : urlrouter2 || "";
  var hlxShareDataObj = {
    app_id: "1", // 请求源APP_ID
    is_success: is_success,
    platform: platform, //分享平台名称{客户端、微信好友、微信朋友圈、QQ好友、QQ空间、新浪微博}
    source_id: source_id, // 如果你埋点的新闻稿件 那这个source_id就是newsId,如果是栏目,就是columnId
    source_type: "news", // 业务源类型{news:新闻,wz:问政,shop:商情,shoot:随手拍,joke:段子,act:活动,topic:话题,moments:发现,newspaper_news:数字报新闻}
    ua: window.navigator.userAgent
  };
  fail_reason ? (hlxShareDataObj.fail_reason = fail_reason) : "";
  console.log(hlxShareDataObj);

  return request.post(_url, hlxShareDataObj);
}
